import { AfterViewInit, Component, HostListener, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ProfileSettingsComponent implements AfterViewInit {
  
  windowType;

  @HostListener("window:resize") onResize() {
    this.deviceType();
  }

  constructor(

  ) {

  }

  ngAfterViewInit(){
    this.deviceType();
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }
}
